<div class="chat-container">
    <div class="file-container" *ngFor="let file of allFiles">
        <div
            class="file-card"
            *ngIf="showConversationUploadProgress() && !progressFlag() && uploadProgress() > 0"
            [id]="isTemporaryFile() ? 'file-card-temporal' : 'file-card-no-temporal'"
        >
            <div class="file-card__info">
                <span
                    class="file-card__container__title"
                    [aidaTooltip]="file.name"
                    aidaTooltipPosition="bottom"
                    tabindex="0"
                    >{{ file.name | truncate: 30 }}
                </span>

                <div class="file-card__meta">
                    <img
                        *ngIf="!!file.iconPath"
                        src="/assets/icons/{{ file.iconPath }}"
                        alt="Icon"
                        class="file-card__icon__negative"
                    />
                    <div class="file-card__type">{{ file.typeName }}</div>
                </div>
            </div>

            <div class="file-card__progress">
                <div class="progress-circle" [style.--value]="uploadProgress()">
                    <span class="progress-circle__value"
                        >{{ uploadProgress() | number: '1.0-2' }}%</span
                    >
                </div>
            </div>
        </div>
        <div class="file-card" *ngIf="!showConversationUploadProgress() || progressFlag()">
            <div class="file-card__info">
                <div class="file-card__container">
                    <span
                        class="file-card__container__title"
                        [aidaTooltip]="file.name"
                        aidaTooltipPosition="bottom"
                        tabindex="0"
                        >{{ file.name | truncate: 30 }}</span
                    >
                    <button
                        type="button"
                        (click)="handleDelete(file)"
                        class="file-card__container__remove"
                        [aidaTooltip]="'Remove file'"
                        aidaTooltipPosition="top"
                        aria-label="Remove file"
                    >
                        <img src="/assets/icons/remove-icon.svg" alt="" />
                    </button>
                </div>
                <div class="file-card__meta">
                    <img
                        *ngIf="!!file.iconPath"
                        src="/assets/icons/{{ file.iconPath }}"
                        alt="Icon"
                        class="file-card__icon"
                    />
                    <div class="file-card__type">{{ file.typeName }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
